import * as React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import {
  Box,
  Typography,
  MenuList,
  MenuItem,
  ListItemText,
  Divider
} from '@mui/material';


export default function Home() {

    return(
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                height: '100%',
            }}
        >
            <Typography variant='h5'>HOME</Typography>
        </Box>
    );
}